/**
 * Environment Detection Utilities
 * 
 * Provides consistent environment detection logic across the theme.
 * Can be used in both JavaScript and through Liquid via inline script execution.
 */

window.EnvironmentUtils = (function() {
  'use strict';

  /**
   * Check if this is a staging environment
   * @returns {boolean} True if staging environment
   */
  function isStagingEnvironment() {
    const hostname = window.location.hostname;
    const port = window.location.port;
    return hostname === 'staging.buno.mx' || 
           hostname === 'buno-shopify.loca.lt' || 
           (hostname === '127.0.0.1' && port != '1234') ||
           hostname.includes('.myshopify.com');
  }

  /**
   * Check if this is local development environment
   * @returns {boolean} True if local development
   */
  function isLocalDevelopment() {
    const hostname = window.location.hostname;
    const port = window.location.port;
    return hostname === '127.0.0.1' && port != '1234';
  }

  /**
   * Check if this is production environment
   * @returns {boolean} True if production environment
   */
  function isProductionEnvironment() {
    return !isStagingEnvironment() && !isLocalDevelopment();
  }

  /**
   * Get current environment type as string
   * @returns {string} 'staging', 'local', or 'production'
   */
  function getEnvironmentType() {
    if (isLocalDevelopment()) return 'local';
    if (isStagingEnvironment()) return 'staging';
    return 'production';
  }

  /**
   * Check if we should redirect to staging (for .myshopify.com preview URLs)
   * @returns {boolean} True if should redirect
   */
  function shouldRedirectToStaging() {
    const hostname = window.location.hostname;
    const search = window.location.search;
    
    // Redirect .myshopify.com preview URLs to staging
    return hostname.endsWith('.myshopify.com') && 
           search.includes('preview_theme_id=153250234580');
  }

  /**
   * Get environment information object
   * @returns {object} Environment info
   */
  function getEnvironmentInfo() {
    return {
      isStaging: isStagingEnvironment(),
      isLocal: isLocalDevelopment(),
      isProduction: isProductionEnvironment(),
      type: getEnvironmentType(),
      hostname: window.location.hostname,
      port: window.location.port,
      shouldRedirect: shouldRedirectToStaging()
    };
  }

  /**
   * Set global environment variables for Liquid compatibility
   * This function can be called immediately to set window.ENVIRONMENT
   */
  function setGlobalEnvironmentVars() {
    window.ENVIRONMENT = getEnvironmentInfo();
  }

  /**
   * Debug function to log environment information
   */
  function debugEnvironment() {
    const info = getEnvironmentInfo();
    console.log('[ENVIRONMENT] Current environment info:', info);
    return info;
  }

  // Set global environment variables immediately
  setGlobalEnvironmentVars();

  // Public API
  return {
    isStagingEnvironment,
    isLocalDevelopment,
    isProductionEnvironment,
    getEnvironmentType,
    shouldRedirectToStaging,
    getEnvironmentInfo,
    setGlobalEnvironmentVars,
    debugEnvironment
  };
})();

// Also expose individual functions globally for backwards compatibility
window.isStagingEnvironment = window.EnvironmentUtils.isStagingEnvironment;
window.isLocalDevelopment = window.EnvironmentUtils.isLocalDevelopment;
window.isProductionEnvironment = window.EnvironmentUtils.isProductionEnvironment;